<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" type="primary" plain @click="onExport" v-if="false"
          >导出</el-button
        >
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="80">
          <template slot-scope="{ row }">
            <el-button
              type="text"
              icon="el-icon-document"
              @click="details(row)"
            ></el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <!--   <edit-dialog ref="editDialog" @close-saved="reload" />  -->
    <details-dialog ref="detailsDialog" @closed="reload" />
  </div>
</template>
  <script>
import curdMixins from "@/mixins/curd";
import list from "@/components/sale/apply/list";
// import editDialog from "@/components/sale/apply/editDialog";
import detailsDialog from "@/components//sale/apply/detailsDialog";

export default {
  name: "apply",
  mixins: [curdMixins],
  components: {
    list,
    // editDialog,
    detailsDialog,
  },
  methods: {
    onExport() {},
    details(row) {
      this.$refs.detailsDialog.openDetails(row);
    },
  },
};
</script>